import Vue from 'vue'

const menu="dinningHall/menudaily/";

export default {

    pagination(dtr,token){return Vue.prototype.$http.post(menu+"NoDailyByDate",dtr);},
    save(obj,usr){
        return Vue.prototype.$http.post(menu+"save",obj,{    params:{usr:usr}});}
} 